// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"27e1043b","347":"fdb5ac54","453":"ab4b9f06"}[chunkId] + ".chunk.js";
};